<template>
<div class="pt630">
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('pt620.labels.title'), routerName: SiteConstants.PG010MAIN, param: {pageNo: '24'}}, {title:$t('pt630.labels.orderHeader'), routerName: '', param: {}}]"></breadcrumb>
    <div class="section page-mypage mb32 ">
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div class="section-inner">
            <h3 v-if="siteFlg == '1'">{{$t('pt630.labels.orderHeader1')}}</h3>
            <h3 v-else>{{$t('pt630.labels.orderHeader')}}</h3>
            <!-- ご注文の詳細です。 -->
            <p class="mb32">{{$t('pt630.labels.myOrders')}}</p>

            <table class="personal mb32 purchase-history">                                   
                <!-- 注文番号 -->
                <tr>
                    <th class="w200">{{$t('pt630.labels.orderNo')}}</th>
                    <td>{{orderHeadInfo.ORDER_CD_TYPICAL}}</td>
                </tr>
                <!-- 注文日 -->
                <tr>
                    <th>{{$t('pt630.labels.newdateOders')}}</th>
                    <td>{{orderHeadInfo.ORDER_TIME}}</td>
                </tr>
                <!-- 支払方法 -->
                <tr>
                    <th>{{$t('pt630.labels.newPayment')}}</th>
                    <td>{{orderHeadInfo.KESSAI_NM}}</td>
                </tr>
                <template v-if="syukkaKanriFlg == 0">
                    <!-- 出荷日 -->
                    <tr>
                        <th>{{$t('pt630.labels.shipDate')}}</th>
                        <td>{{orderHeadInfo.SYUKKA_YMD}}</td>
                    </tr>
                    <!-- お問い合わせ番号 -->
                    <tr>
                        <th>{{$t('pt630.labels.optionLabel')}}</th>
                        <td>
                            <div v-for="(orders, index) in orderDetailsInfo" :key="index">
                                <div v-if="orders.ORDER_NO == orders.ORDER_NO ">
                                    <span v-if="orders.TRANS_CO_KBN == 'JP'"><a :href="linkJP">{{orders.OKURINO}}</a></span>
                                    <span v-else>{{orders.OKURINO}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <!-- 顧客CD -->
                <tr>
                    <th>{{dispKokyakuCdNm}}</th>
                    <td>{{orderHeadInfo.KOKYAKU_CD}}</td>
                </tr>
                <!-- 注文者名 -->
                <tr>
                    <th>{{$t('pt630.labels.kokyakuNm')}}</th>
                    <td>{{orderHeadInfo.KOKYAKU_NM}}</td>
                </tr>
            </table>
            <br>
            <div v-for="(orders, index) in orderDetailsInfo" :key="index">
                <!-- お届先情報 -->
                <p class="mb32">{{$t('pt630.labels.DeliveryInformation')}}{{index+1}}</p>
                <div v-for="(orders, index2) in orderDetailsInfo" :key="index2">
                    <table v-if="index == index2" class="purchase-history">
                        <!-- 配送先名 -->
                        <tr>
                            <th class="w200">{{$t('pt630.labels.deliName')}}</th>
                            <td v-if="siteFlg == '1'">
                                <span>{{orders.TDK_NM1}}</span>
                                <span>{{$t('pt630.labels.direct')}}</span>
                                <span v-if="orders.GIFT_KBN == '0'">{{$t('pt630.labels.usCompany')}}</span>
                                <span v-else >{{$t('pt630.labels.directDelivery')}}</span>
                            </td>
                            <td v-else><span >{{orders.TDK_NM1}}</span></td>
                        </tr>
                        <!-- 配送先名カナ -->
                        <tr>
                            <th>{{$t('pt630.labels.kanaName')}}</th>
                            <td>{{orders.TDK_KANA}}</td>
                        </tr>
                        <!-- 配送先郵便番号 -->
                        <tr>
                            <th>{{$t('pt630.labels.postalCode')}}</th>
                            <td>〒{{orders.TDK_ZIP}}</td>
                        </tr>
                        <!-- 配送先住所 -->
                        <tr>
                            <th>{{$t('pt630.labels.shipAddress')}}</th>
                            <td>{{orders.TDK_ADDR1}}{{orders.TDK_ADDR2}}{{orders.TDK_ADDR3}}</td>
                        </tr>
                        <!-- 配送先電話番号 -->
                        <tr>
                            <th>{{$t('pt630.labels.phoneNumber')}}</th>
                            <td>{{orders.TDK_TEL1}}</td>
                        </tr>
                        <!-- 配達指定 -->
                        <tr v-if="pt630Init.tdkkibouFlg == 1 || pt630Init.tdkTimeFlg == 1">
                            <th>{{$t('pt630.labels.deliDes')}}</th>
                            <td>
                                <span v-if="pt630Init.tdkkibouFlg == 1">{{$t('pt630.labels.newDeliDate')}}&nbsp;{{orders.TDK_YMD}}</span>
                                <br>
                                <span v-if="pt630Init.tdkTimeFlg == 1">{{$t('pt630.labels.timeZone')}}&nbsp;{{orders.HSTM}}</span>
                            </td>
                        </tr>
                        <!-- ギフト指定 -->
                        <tr v-if="pt630Init.giftFlg == 1">
                            <th>{{$t('pt630.labels.giftDes')}}</th>
                            <td v-if="orders.GIFT_KBN == '0'">
                                {{$t('pt630.labels.usCompany')}}
                            </td>
                            <td v-else>
                                {{$t('pt630.labels.directDelivery')}}
                            </td>
                        </tr>
                    </table>
                </div>
                <br>
                <table class="mb32">
                    <thead>
                        <tr>
                            <!-- 商品コード -->
                            <th scope="col" class="w160">{{$t('common.labels.productCode')}}</th>
                            <!-- 商品名 -->
                            <th scope="col">{{$t('common.labels.productName')}}</th>
                            <!-- 単価-->
                            <th scope="col" class="w80">{{$t('common.labels.unitPrice')}}</th>
                            <!-- 数量 -->
                            <th scope="col" class="w80">{{$t('common.labels.quantity')}}</th>
                            <!-- 金額 -->
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'" scope="col" class="w160">
                                {{$t('pt630.labels.kingakuStr')}}
                                <span class="price-tax">{{$t('common.labels.taxincluded')}}</span>
                            </th>
                            <th v-else scope="col" class="w100">
                                {{$t('pt630.labels.kingakuStr')}}
                                <span class="price-tax">{{$t('common.labels.excludingtax')}}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(orders2,index) in orderProductsInfo" :key="index">
                        <tr v-if="orders.ORDER_NO == orders2.ORDER_NO ">
                            <!--商品CD -->
                            <td scope="row" :aria-label="$t('common.labels.productCode')">{{orders2.S_ITEM_CD}}</td>
                            <!--商品名 -->
                            <td :aria-label="$t('common.labels.productName')">
                                {{orders2.ITEM_NM}}
                            </td>
                            <!--単価-->
                            <td v-if="orderHeadInfo.TNK_DSP_KBN == '1'" class="cart-price" :aria-label="$t('common.labels.unitPrice')">
                                <span>
                                    <input-number v-model="orders2.TNK_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <td v-else class="cart-price" :aria-label="$t('common.labels.unitPrice')">
                                <span>
                                    <input-number v-model="orders2.TNK_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <!--数量 -->
                            <td class="cart-num" :aria-label="$t('common.labels.quantity')">{{orders2.QTY}}</td>
                            <!--金額(税込) -->
                            <td v-if="orderHeadInfo.TNK_DSP_KBN == '1'" class="cart-price" :aria-label="$t('pt630.labels.kingakuStrTax')">
                                <span class="price">
                                    <input-number v-model="orders2.IN_QTY" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                            <!--金額(税抜) -->
                            <td v-else class="cart-price" :aria-label="$t('pt630.labels.kingakuStrTax1')">
                                <span class="price">
                                    <input-number v-model="orders2.EX_QTY" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="personal shopping-total mb32 purchase-history">
                    <!-- 小計 -->
                    <tr>
                        <th class="w160" v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                            {{$t('sh060.labels.itemValueSubtotalin')}}
                        </th>
                        <th class="w160" v-else>
                            {{$t('sh060.labels.itemValueSubtotalex')}}
                        </th>
                        <td class="cart-price">
                            <span class="price" v-if="orderHeadInfo.TNK_DSP_KBN == '1'">
                                <input-number v-model="orderHeadInfo.ITEMSUM_TAX_IN" :readonly="true" :suffix ="'円'"/>
                            </span>
                            <span class="price" v-else>
                                <input-number v-model="orderHeadInfo.ITEMSUM_TAX_EX" :readonly="true" :suffix ="'円'"/>
                            </span>
                        </td>
                    </tr>
                    <!-- 送料 -->
                    <template v-if="soryoDispFlg == 1">
                        <tr>
                            <th>{{$t('pt630.labels.cost')}}</th>
                            <td class="cart-price">
                                <span class="price" >
                                    <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.SORYO_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                    <input-number v-else v-model="orderHeadInfo.SORYO_TAX_EX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                    </template>
                    <!-- 代引手数料 -->
                    <tr v-if="orderHeadInfo.KESSAI_CD == '2'">
                        <th>{{$t('pt630.labels.cod')}}</th>
                        <td class="cart-price">
                            <span class="price">
                                <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.DAI_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                <input-number v-else v-model="orderHeadInfo.DAI_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                            </span>
                        </td>
                    </tr>
                    <!-- 払込手数料 -->
                    <tr v-if="orderHeadInfo.KESSAI_CD == '3'">
                        <th>{{$t('sh060.labels.paymentslipfee')}}</th>
                        <td class="cart-price">
                            <span class="price">
                                <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.PAY_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                <input-number v-else v-model="orderHeadInfo.PAY_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                            </span>
                        </td>
                    </tr>
                    <!-- 決済手数料 -->
                    <tr v-if="orderHeadInfo.KESSAI_CD == '80'">
                        <th>{{$t('sh060.labels.kessaiTesuTitle')}}</th>
                        <td class="cart-price">
                            <span class="price">
                                <input-number v-if="orderHeadInfo.TNK_DSP_KBN == '1'" v-model="orderHeadInfo.KESSAI_TESU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                <input-number v-else v-model="orderHeadInfo.KESSAI_TESU_TAX_EX" :readonly="true" :suffix ="'円'"/>
                            </span>
                        </td>
                    </tr>
                    <!--利用ポイント -->
                    <tr v-if="stringNvl(orderHeadInfo.POINT_USED,'0') != '0'">
                        <th>{{$t('sh060.labels.pointstousethistime')}}</th>
                        <td class="cart-price">
                            <span class="price">
                                {{stringNvl(orderHeadInfo.POINT_USED,'0')}}{{$t("sh050.labels.pt")}}
                            </span>
                        </td>
                    </tr>
                    <!-- キャンペーン値引 -->
                    <tr v-if="stringNvl(orderHeadInfo.NEBIKI,'0') != '0'">
                        <th>{{$t('sh060.labels.campaigndiscount')}}</th>
                        <td class="cart-price">
                            <span class="price">
                                <input-number v-model="orderHeadInfo.NEBIKI" :readonly="true" :suffix ="'円'"/>
                            </span>
                        </td>
                    </tr>
                    <!-- 消費税 -->
                    <template v-if="syouhiZeiDispFlg == 1">
                        <tr>
                            <th v-if="orderHeadInfo.TNK_DSP_KBN == '1'">{{$t('pt630.labels.newConsumption')}}</th>
                            <th v-else>{{$t('pt630.labels.consumptionTax')}}</th>
                            <td class="cart-price">
                                <span class="price">
                                    <input-number v-model="orderHeadInfo.SEIKYU_TAX" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                    </template>
                    <!-- 請求金額 -->
                    <template v-if="seikyuuKinDispFlg == 1">
                        <tr>
                            <th class="w160">
                                {{$t('sh060.labels.billedamount(taxincluded)')}}
                            </th>
                            <td class="cart-price">
                                <span class="price">
                                    <input-number v-model="orderHeadInfo.SEIKYU_TAX_IN" :readonly="true" :suffix ="'円'"/>
                                </span>
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
            <ul class="button-column">
                <!-- 前のページへ戻る -->
                <li><input class="submit-button back-btn" type="submit" name="submitButtonName" @click="backStep()" onkeypress="backStep()" :value="$t('common.labels.backButton')"></li>
                <template v-if="loginSiteCd == orderHeadInfo.SITE_CD">
                    <!-- 再注文 -->
                    <li v-if="reOrderFlg == 1">
                        <input class="submit-button" type="submit" name="submitButtonName" @click="pt630reOderAllowSameItemAddCheck()" onkeypress="pt630reOderAllowSameItemAddCheck()" :value="$t('common.labels.buttonOders')">
                    </li>
                    <!--注文変更 -->
                    <li v-if="orderChangeFlg == 1 && orderKakuteiFlg == 0 && cancelFlg == 0">
                        <input class="submit-button" type="submit" name="submitButtonName" @click="pt630orderChange()" onkeypress="pt630orderChange()" :value="$t('pt630.buttons.change')">
                    </li>
                    <!--注文キャンセル -->
                    <li v-if="orderCancelFlg == 1 && orderKakuteiFlg == 0 && cancelFlg == 0">
                        <input class="submit-button decision" type="submit" name="submitButtonName" @click="pt630orderCancel()" onkeypress="pt630orderCancel()" :value="$t('common.buttons.cancel')">
                    </li>
                </template>
            </ul>
            <br>
        </div><!-- /.section-inner -->
    </div><!-- /.section page-mypage mb32 -->
</div>  
</template>

<script>
/* 
* Import libs and componnents 
*/
import axios from "assets/js/request";
import common from "assets/js/common";
import DataTable from 'components/Datatable';
import InputCheck from 'components/InputCheck';
import Message from 'components/Message';
import DownloadFile from 'components/DownloadFile';
import DatePickers from 'components/DatePicker';
import InputNumber from "components/InputNumber";
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /* 
    * Name of component
    */
    name: "PT630MemberOrderHisDetParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        DataTable,
        Message,
        DatePickers,
        InputCheck,
        DownloadFile,
        InputNumber,
        Breadcrumb
    },
    /* 
    * Declare variable and set default value
    */
    data: function() {
        return {
            orderDetailsInfo:[],
            orderProductsInfo:[],
            orderHeadInfo:{},
            orderTotInfo:{},
            reqModel:{
                fBaFLG:null,
                orderCdTypical:null,
                orderNo: null
            },
            pt630reqModel:{
                fBaFLG:null,
                orderNo:null,
                orderCdTypical:null,
            },
            pt630Init: {

            },
            siteFlg: null,
            requestBack:{},
            SiteConstants:SiteConstants,
            soryoKin: null,
            uketoriKin: null,
            usePoint: null,
            linkJP: null,
            linkSG: null,
            linkYA: null,
            orderCancelFlg: null,
            orderKakuteiFlg: null,
            orderChangeFlg: null,
            cancelFlg: null,
            syukkaKanriFlg:0,
            site: "",
            loginSiteCd:"",
            soryoDispFlg:0,
            syouhiZeiDispFlg:0,
            reOrderFlg:0,
            seikyuuKinDispFlg:0,
            dispKokyakuCdNm:""
        }
    },
    /* 
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        //Call API doInit
        if (_this.ptInitData){
            _this.orderDetailsInfo = _this.ptInitData.orderDetailsInfo;
            _this.orderProductsInfo = _this.ptInitData.orderProductsInfo;
            _this.orderTotInfo = _this.ptInitData.orderTotInfo[0];
            _this.orderHeadInfo = _this.ptInitData.orderHeadInfo[0];
            _this.soryoKin = _this.ptInitData.soryoKin;
            _this.uketoriKin = _this.ptInitData.uketoriKin;
            _this.usePoint = _this.ptInitData.usePoint;
            _this.orderCancelFlg = _this.ptInitData.orderCancelFlg;
            _this.orderKakuteiFlg = _this.ptInitData.orderKakuteiFlg;
            _this.orderChangeFlg = _this.ptInitData.orderChangeFlg;
            _this.cancelFlg = _this.ptInitData.cancelFlg;
            _this.syukkaKanriFlg = _this.ptInitData.syukkaKanriFlg;
            _this.soryoDispFlg = _this.ptInitData.soryoDispFlg;
            _this.syouhiZeiDispFlg = _this.ptInitData.syouhiZeiDispFlg;
            _this.pt630Init = _this.ptInitData;
            _this.pt630reqModel = Object.assign({}, _this.pt630reqModel, _this.ptInitData.reqModels);
            _this.loginSiteCd = _this.ptInitData.loginSiteCd;
            _this.reOrderFlg = _this.ptInitData.reOrderFlg
            _this.seikyuuKinDispFlg = _this.ptInitData.seikyuuKinDispFlg;
            _this.dispKokyakuCdNm = _this.ptInitData.dispKokyakuCdNm
            //Replace link
            _this.linkJP = _this.ptInitData.linkJP.replace('[1]',_this.orderDetailsInfo.OKURINO);
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT630 + _this.$UrlConstants.DO_INIT, _this.pt630reqModel).then(function(response) {
                _this.orderDetailsInfo = response.data.orderDetailsInfo;
                _this.orderProductsInfo = response.data.orderProductsInfo;
                _this.orderTotInfo = response.data.orderTotInfo[0];
                _this.orderHeadInfo = response.data.orderHeadInfo[0];
                _this.soryoKin = response.data.soryoKin;
                _this.uketoriKin = response.data.uketoriKin;
                _this.usePoint = response.data.usePoint;
                _this.orderCancelFlg = response.data.orderCancelFlg;
                _this.orderKakuteiFlg = response.data.orderKakuteiFlg;
                _this.orderChangeFlg = response.data.orderChangeFlg;
                _this.cancelFlg = response.data.cancelFlg;
                _this.syukkaKanriFlg = response.data.syukkaKanriFlg;
                _this.soryoDispFlg = response.data.soryoDispFlg;
                _this.syouhiZeiDispFlg = response.data.syouhiZeiDispFlg;
                _this.pt630Init = response.data;
                _this.pt630reqModel = Object.assign({}, _this.pt630reqModel, response.data.reqModels);
                _this.loginSiteCd = response.data.loginSiteCd;
                _this.reOrderFlg = response.data.reOrderFlg
                _this.seikyuuKinDispFlg = response.data.seikyuuKinDispFlg;
                _this.dispKokyakuCdNm = response.data.dispKokyakuCdNm
                //Replace link
                _this.linkJP = response.data.linkJP.replace('[1]',_this.orderDetailsInfo.OKURINO);
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /* 
    * Methods
    */
    methods: {
        /* 
        * Function order 
        */
        pt630reOderAllowSameItemAddCheck: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_ORDER, _this.pt630reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                     _this.$emit("event-loading", false);
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        var info = "";
                        for(var mesg = 0;  mesg < response.data.response.info.length; mesg++ ){
                            info = info + response.data.response.info[mesg].messageList[0].message;
                            info = info + '\n';
                        }
                        alert(info);
                    } 
                    if (response.data.response.hasItemAdded != null && response.data.response.hasItemAdded == 1){
                            if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                                info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                                info = info + '\n';
                                alert(info);
                            } 
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                        //}
                    } else {
                        if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                            info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                            info = info + '\n';
                            alert(info);
                        } 
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    }
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /* 
        * Function order 
        */
        pt630reOder: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT430 + _this.$UrlConstants.DO_ORDER, _this.pt630reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        alert(response.data.response.info);
                    } else {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    }
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        pt630orderCancel: function(){
            var _this = this;
            if (!confirm( _this.$i18n.t('pt630.labels.orderCancelMessage') )) return;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT630 + _this.$UrlConstants.DO_CANCEL, _this.pt630reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 24}});
                } else {
                    alert('注文確定済みのためキャンセルできませんでした。');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        // 商品レビュー画面へ
        pt630review: function(itemCd,orderCd) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 83, itemCd: itemCd}, params: {orderCd: orderCd,itemCd: itemCd}} );
        },
        //function back
        backStep: function(){
            var _this = this;
            //function back
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 24}, params: {requestBack:_this.requestBack}});
        },
        stringNvl: function(strVal, defVal){
            if(strVal==undefined){
                return defVal;
            }else{
                return strVal;
            }
        },
        /* 
        * Function 注文変更処理
        */
        pt630orderChange: function(){
            var _this = this;
            //カートの中身をクリアします。\nよろしいですか？
            if (!confirm( _this.$i18n.t('pt630.labels.changeMessage') )) return;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT620 + _this.$UrlConstants.DO_ORDER_CHANGE, _this.pt630reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                     _this.$emit("event-loading", false);
                    if (response.data.response.info != null && response.data.response.info.length > 0){
                        var info = "";
                        for(var mesg = 0;  mesg < response.data.response.info.length; mesg++ ){
                            info = info + response.data.response.info[mesg].messageList[0].message;
                            info = info + '\n';
                        }
                        alert(info);
                    } 
                    if (response.data.response.hasItemAdded != null && response.data.response.hasItemAdded == 1){
                            if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                                info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                                info = info + '\n';
                                alert(info);
                            } 
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    } else {
                        if (response.data.response.infoZaiko != null && response.data.response.infoZaiko.length > 0){
                            info = info + response.data.response.infoZaiko[mesg].messageList[0].message;
                            info = info + '\n';
                            alert(info);
                        } 
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                    }
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(!common.isNullItem(error)){
                    if(!common.isNullItem(error.response)){
                        if(406 == error.response.status){
                            var listId = common.excuteValidation(error);
                            _this.listIdErr.push.apply(_this.listIdErr, listId);
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
    },
    
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = this.$route.query;
        if(queryData != null){
            _this.pt630reqModel.fBaFLG = queryData.fBaFlg;
            _this.pt630reqModel.orderNo = queryData.orderNo;
            _this.pt630reqModel.orderCdTypical = queryData.orderCdTypical;
        }
        if(Object.keys(paramData).length > 0){
            _this.pt630reqModel.fBaFLG = paramData.fBaFlg;
            _this.pt630reqModel.orderCdTypical = paramData.orderCdTypical;
            _this.pt630reqModel.orderNo= paramData.orderNo;
            _this.requestBack = paramData.requestBack;
        } 
    }
}
</script>
